"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("@lingui/react");

var _react2 = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _core = require("@lingui/core");

var _blocks = require("@bueno/blocks");

var _actionsUI = require("../../../../redux/modules/_BETA/actionsUI");

var _NoResultsOverlay = _interopRequireDefault(require("../../../NoResultsOverlay"));

var _ListHeader = _interopRequireDefault(require("../ListHeader"));

var _ListRow = _interopRequireDefault(require("../ListRow"));

var _ListView = require("./ListView.styles");

const DEFAULT_NUM_ROWS = 10;

function mapStateToProps(state) {
  return {
    sortFilter: state.betaActionsUI.sortFilter,
    sortDirection: state.betaActionsUI.sortDirection,
    user: state.auth.user
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateSort: key => dispatch((0, _actionsUI.updateSortFunc)(key))
  };
}

const ListView = props => {
  const [numRowsVisible, setNumRowsVisible] = _react2.default.useState(DEFAULT_NUM_ROWS);

  const [lastActive, setLastActive] = _react2.default.useState(props.activeActionId);

  _react2.default.useEffect(() => {
    if (props.activeActionId !== undefined) {
      setLastActive(props.activeActionId);
    }
  }, [props.activeActionId]);

  const handleShowMore = _react2.default.useCallback(() => {
    setNumRowsVisible(state => state + DEFAULT_NUM_ROWS);
  }, [numRowsVisible]);

  const handleShowAll = _react2.default.useCallback(() => {
    setNumRowsVisible(props.rows.length);
  }, [props.rows.length]);

  const calculateMoreToShow = () => {
    const remainingCount = props.rows.length - numRowsVisible;
    return remainingCount > DEFAULT_NUM_ROWS ? DEFAULT_NUM_ROWS : remainingCount;
  };

  const handleClickHeader = _react2.default.useCallback(key => () => {
    props.updateSort(key);
  }, []);

  const visible = _react2.default.useMemo(() => props.rows.slice(0, numRowsVisible), [numRowsVisible, props.rows]);

  const {
    sortFilter,
    sortDirection
  } = props;
  return /*#__PURE__*/_react2.default.createElement(_react2.default.Fragment, null, /*#__PURE__*/_react2.default.createElement(_ListView.Container, null, /*#__PURE__*/_react2.default.createElement(_ListView.Content, null, props.noResults && /*#__PURE__*/_react2.default.createElement(_NoResultsOverlay.default, {
    noResultsMessage: true
  }), /*#__PURE__*/_react2.default.createElement(_react2.default.Fragment, null, /*#__PURE__*/_react2.default.createElement(_blocks.DataGrid, {
    group: [{
      start: 1,
      end: 3
    }, {
      start: 4,
      end: 7
    }, {
      start: 7,
      end: 8
    }],
    cellProps: {
      type: 'dense',
      density: 'default'
    },
    columns: 9,
    gridTemplateColumns: ['min-content', // id
    'minmax(80px, max-content)', // updated
    'min-content', // status
    'minmax(120px, max-content)', // site
    'minmax(240px, 1fr)', // summary
    'min-content', // severity
    'min-content', // type
    'min-content', // team
    'auto' // est. savings
    ]
  }, /*#__PURE__*/_react2.default.createElement(_ListHeader.default, {
    sortFilter: sortFilter,
    sortDirection: sortDirection,
    i18n: _core.i18n,
    handleClickHeader: handleClickHeader
  }), visible.map(row => /*#__PURE__*/_react2.default.createElement(_ListRow.default, {
    onClick: props.onRowClick(row.key),
    isActive: lastActive === row.key,
    context: row.context,
    key: row.key,
    id: row.key,
    summary: row.summary,
    priority: row.priority,
    status: row.bonfire_status,
    updatedAt: row.updated,
    responsible: row.responsible,
    siteName: row.components,
    projectName: row.project_name,
    projectKey: row.project_key,
    assignee: row.bonfire_assignee,
    savings: {
      operational: row.operational_savings,
      totalImpact: row.total_financial_impact,
      electricity: row.elec,
      thermal: row.thermal,
      gas: row.gas,
      water: row.water
    }
  }))), /*#__PURE__*/_react2.default.createElement(_blocks.DataGridFooter, null, /*#__PURE__*/_react2.default.createElement(_ListView.StyledThirds, null, /*#__PURE__*/_react2.default.createElement(_blocks.Left, null, /*#__PURE__*/_react2.default.createElement(_blocks.Body, null, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
    id: "show_more_actions_footer_row.v2.showing_count",
    values: {
      0: visible.length,
      1: props.rows.length
    }
  }))), /*#__PURE__*/_react2.default.createElement(_blocks.Center, null, /*#__PURE__*/_react2.default.createElement(_blocks.ControlGroup, {
    tight: true
  }, props.rows.length > visible.length && /*#__PURE__*/_react2.default.createElement(_blocks.Button, {
    primary: true,
    thin: true,
    appearance: "outline",
    onClick: handleShowMore
  }, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
    id: "show_more_actions_footer_row.v3.show_more",
    values: {
      0: calculateMoreToShow()
    }
  })), props.rows.length > visible.length && /*#__PURE__*/_react2.default.createElement(_blocks.Button, {
    primary: true,
    thin: true,
    appearance: "plain",
    onClick: handleShowAll
  }, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
    id: "show_more_actions_footer_row.v3.show_all",
    values: {
      0: props.rows.length
    }
  })))), /*#__PURE__*/_react2.default.createElement(_blocks.Right, null)))))));
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ListView);

exports.default = _default;
module.exports = exports.default;